import {
  HomeOutlined,
  RoofingOutlined,
  CableOutlined,
  GridOnOutlined,
  GridOffOutlined,
  ShoppingCartOutlined,
  IndeterminateCheckBoxOutlined,
  Sick,
  EmojiTransportation,
  ViewCarousel,
  School,
  BeachAccess,
} from '@lichtblick/icons';

export const getIcon = (variant: string) => {
  switch (variant) {
    case 'Vor-Ort-Termin':
      return <HomeOutlined />;
    // Todo: for later
    // case 'B':
    //   return <CallOutlined />;
    case 'DC-Montagetermin':
    case 'DC-Nachbesserungstermin (InSe-verschuldet)':
    case 'DC-Nachbesserungstermin (Kunde-verschuldet)':
      return <RoofingOutlined />;
    case 'AC Installation':
    case 'AC-Montagetermin':
      return <CableOutlined />;
    case 'Zählersetzungstermin':
      return <IndeterminateCheckBoxOutlined />;
    case 'Gerüstaufbau':
      return <GridOnOutlined />;
    case 'Gerüstabbau':
      return <GridOffOutlined />;
    case 'Warenlieferung':
      return <ShoppingCartOutlined />;
    case 'Urlaub':
    case 'Feiertag':
      return <BeachAccess />;
    case 'Krank':
      return <Sick />;
    case 'Buerotag':
      return <EmojiTransportation />;
    case 'Puffertag':
      return <ViewCarousel />;
    case 'Schulung':
      return <School />;
    // Todo: for later
    // case 'I':
    //   return <LightbulbOutlined />;
    // case 'J':
    //   return <BedOutlined />;
    // case 'K':
    //   return <ApartmentOutlined />;
    // case 'L':
    //   return <WbSunnyOutlined />;
  }
};
